import { ntvb, tokenStorage } from './kmm';
import { JsonWebTokenUtils } from '@norlys-a-s/norlys-play-kmm';
import { storePersistentData } from '../persistent-data/persistent-data';

export type ExchangeCredentialsForTokensParams = {
  email: string;
  password: string;
};

export async function loginWithEmailPassword({
  email,
  password
}: ExchangeCredentialsForTokensParams) {
  const tokenResponse = await ntvb(
    (repo) => repo.exchangeCredentialsForTokens(email, password),
    false
  );

  if (!tokenResponse?.accessToken) {
    throw new Error('Login failed: no access token received');
  }

  tokenStorage.saveTokens(tokenResponse.accessToken, tokenResponse.refreshToken);

  const jwUtils = new JsonWebTokenUtils();
  const customerId = jwUtils.parseJwtPayloadToUserIdentifier(tokenResponse.accessToken);

  storePersistentData('customerId', customerId);

  return tokenResponse;
}
